'use strict';
'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _eventEmitter = require('event-emitter');

var _eventEmitter2 = _interopRequireDefault(_eventEmitter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NetworkProvider = function () {
    function NetworkProvider() {
        (0, _classCallCheck3.default)(this, NetworkProvider);

        (0, _eventEmitter2.default)(this);
        this.providers = [];
    }

    (0, _createClass3.default)(NetworkProvider, [{
        key: 'addProvider',
        value: function addProvider(provider) {
            var _this = this;

            this.providers.push(provider);
            provider.on('networks', function (networks) {
                _this.emit('networks', _this.availableNetworks());
            });
        }
    }, {
        key: 'availableNetworks',
        value: function availableNetworks() {
            var networks = (0, _create2.default)(null);

            this.providers.forEach(function (provider) {
                var pType = provider.type;
                if (provider.networks.length > 0) {
                    networks[pType] = networks[pType] || [];
                    networks[pType] = networks[pType].concat(provider.networks);
                }
            });

            return networks;
        }
    }]);
    return NetworkProvider;
}();

exports.default = NetworkProvider;
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["NetworkProvider"]
window._kiwi_exports.libs.NetworkProvider = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./src/libs/NetworkProvider.js
// module id = EKUm
// module chunks = 1